export default "__VITE_ASSET__Qsq8FYsF__"